require('imports-loader?JSON=>window.JSON!./Scripts/Core/json2.js');
window._ = require('./Scripts/Core/underscore.js');
require('./Scripts/Core/jquery.js');
require('./Scripts/Core/jquery.parseJSON.dates.js');
require('./Scripts/Core/jquery.postJSON.js');
require('./Scripts/Core/knockout-3.0.0.debug.js');
window.moment = require('moment');
require('imports-loader?this=>window,exports=>undefined!./Scripts/Plugins/moment/locale/en-ca.js');
require('imports-loader?this=>window,exports=>undefined!./Scripts/Plugins/moment/locale/en-gb.js');
require('./Scripts/Plugins/moment/lang/en-za.js');
require('imports-loader?this=>window,exports=>undefined!./Scripts/Plugins/moment/locale/fr-ca.js');
require('imports-loader?this=>window,exports=>undefined!./Scripts/Plugins/moment/locale/es.js');
require('./Scripts/Plugins/moment/lang/reset.js');
require('./Scripts/Common/InitNamespaces.js');
require('./Scripts/Common/UserAgent.js'); //before Globalization!
require('./Scripts/Common/Globalization.js');
require('./Scripts/App/Core/Mapping/CustomPopupHelper.js');
require('./Scripts/App/Core/Mapping/FeatureLayerHelper.js');
require('./Scripts/App/Core/Mapping/GraphicsLayerHelper.js');
require('./Scripts/App/Core/Mapping/GraphicHelper.js');
require('./Scripts/App/Core/Mapping/EsriRoutingHelper.js');
require('./Scripts/App/Core/Mapping/MappingEsri.js');
require('./Scripts/App/TrackMap/TechTrackMap.js');
require('./Scripts/App/TrackMap/TechTrackUtils.js');
require('./Scripts/App/TrackMap/TechTrackModel.js');
